import { render, staticRenderFns } from "./CollectTemplateLink.vue?vue&type=template&id=6752f4f4"
import script from "./CollectTemplateLink.vue?vue&type=script&lang=js"
export * from "./CollectTemplateLink.vue?vue&type=script&lang=js"
import style0 from "./CollectTemplateLink.vue?vue&type=style&index=0&id=6752f4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports